import React from 'react';
import './Radio.css';

const Radio = ({ 
  name, 
  options, 
  value, 
  onChange, 
  label,
  errorMessage,
  errorClass,
  disabled = false
}) => {
  const handleChange = (optionValue) => {
    if (!disabled && onChange) {
      onChange(optionValue);
    }
  };

  return (
    <div className={`radio-container ${errorClass ? 'is-invalid' : ''}`}>
      {label && <label className="radio-group-label">{label}</label>}
      
      <div className="radio-options">
        {options.map((option) => (
          <label 
            key={option.value} 
            className={`radio-item ${value === option.value ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => handleChange(option.value)}
              disabled={disabled}
            />
            <span className="custom-radio-label">{option.label}</span>
          </label>
        ))}
      </div>
      
      {errorMessage && (
        <div className="radio-error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default Radio;
